<template>
  <div
    class="text-input"
    :class="{
      [`text-input--${view}`]: true,
      'text-input--error': errors.length > 0,
    }"
  >
    <label :for="`input-${uniqueID}`" class="text-input__label" v-if="title">
      {{ title }}
    </label>
    <div class="text-input__block">
      <input
        :id="`input-${uniqueID}`"
        :type="type"
        class="text-input__el"
        :name="name"
        @input="processInput"
        :placeholder="placeholder"
        v-mask="mask"
        v-model="text"
        :autocomplete="autocomplete"
        :readonly="readonly"
        ref="inputEl"
        @keypress.enter="emitEnterPress"
        maxlength="75"
      />
      <div class="text-input__errors" v-if="errors.length > 0">
        <div class="text-input__error">{{ $t(errors[0].$message) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  model: {
    prop: "value",
    event: "update",
  },
  props: {
    name: String,
    title: String,
    placeholder: String,
    value: [String, Number],
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    mask: {
      type: [String, Function],
      default: null,
    },
    view: {
      type: String,
      default: "base",
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    autocomplete: {
      type: String,
      default: "off",
    },
  },
  data() {
    return {
      text: "",
      uniqueID: "",
    };
  },
  created() {
    this.text = this.value || "";
    this.uniqueID = Math.random().toString(36).substr(2, 9);
  },
  watch: {
    value: function () {
      this.text = this.value;
    },
  },
  methods: {
    processInput() {
      if (!this.readonly) {
        this.$emit("update", this.text);
      }
    },
    focus() {
      this.$refs.inputEl.focus();
    },
    emitEnterPress() {
      this.$emit("enterPressed");
    },
  },
};
</script>

<style lang="scss" scoped></style>
